export default "__VITE_ASSET__CrOTnkxN__"